module.exports = __webpack_public_path__ + "img/Untitled-1-711x800.def57fc5.jpg";